<template lang="html">
  <div class="legal-document-source-download mt-6 border-t border-default pt-4">
    <a
      :href="href"
      :download="filename"
      class="inline-flex w-full items-center justify-center gap-2 rounded-none border border-default px-4 py-2 text-sm font-medium text-default transition-colors hover:bg-elevated sm:w-auto"
    >
      <UIcon name="i-lucide-download" class="size-4" />
      Скачать исходный документ (PDF)
    </a>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  href: string
  filename: string
}>()
</script>
